import React, { Component } from 'react';
import { Jumbotron, Container } from 'reactstrap';
import { Row, Col, Card, CardImg, CardTitle, CardText, CardBody } from 'reactstrap';
import { NavLink as Link } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import firebase from 'firebase/app';

export class Events extends Component {
    render() {
        let viewAll;
        let data = this.props.data;
        let cards;
        if (data.length <= 0 | data === undefined) {
            if (!this.props.displayMine) {
                cards = <p id="noProgramsMessage" className="text-color-theme-4 kurb-med pl-5">No Events Available YET! Please Check Back Later! :D</p>
            }
        } else {
            // display three events in home page
            if (this.props.viewAll === "false") {
                viewAll = <Col sm="2" className="d-inline-block text-right kurb-bd pt-2"><p className="mb-0"><Link to="/browse" className="text-white">View All</Link></p></Col>;
                cards = data.slice(0, 3).map((event) => {
                    return <RenderEventCard key={event.id} data={event} />;
                });
            } else {
                // display events created by current organizer on their page
                if (this.props.displayMine) {
                    let organizer = this.props.user.uid;
                    data = data.filter(EventObject => EventObject.organizer === organizer);
                }
                cards = data.map((event) => {
                    return <RenderEventCard key={event.id} data={event} removeEvent={this.props.removeEvent} displayMine={this.props.displayMine} />;
                })
            }
        }

        let renderModal;
        if (this.props.logInOrg & this.props.modal) {
            renderModal = <RenderModal user={this.props.user} />;
        } else {
            renderModal = "";
        }

        return (
            <Jumbotron fluid className="p-5 mt-4 rounded">
                <Container fluid className="pb-2">
                    <Row>
                        <Col sm="10">
                            <h1 className="text-color-theme-1 kurb-bd">{this.props.title}</h1>
                        </Col>
                        {viewAll}
                    </Row>
                </Container>
                <Container width="100%" fluid>
                    <Row id="event-cards">
                        {cards}
                        {renderModal}
                    </Row>
                </Container>
            </Jumbotron>
        );
    }
}

export class RenderModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            newEvent: {}
        };

        this.toggle = this.toggle.bind(this);
    }

    // toggle modal open & close
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal,
        }));
    }

    addEventTitle = (evt) => {
        this.setState({
            newEvent: {
                ...this.state.newEvent,
                eventTitle: evt.target.value
            }
        })
    }

    addEventPlace = (evt) => {
        this.setState({
            newEvent: {
                ...this.state.newEvent,
                place: evt.target.value
            }
        })
    }

    addEventCity = (evt) => {
        this.setState({
            newEvent: {
                ...this.state.newEvent,
                city: evt.target.value
            }
        })
    }

    addEventState = (evt) => {
        this.setState({
            newEvent: {
                ...this.state.newEvent,
                state: evt.target.value.toUpperCase()
            }
        })
    }

    addEventDate = (evt) => {
        // convert user input date to a certain format
        let dateConverter = {
            'January': '01',
            'February': '02',
            'March': '03',
            'April': '04',
            'May': '05',
            'June': '06',
            'July': '07',
            'August': '08',
            'September': '09',
            'October': '10',
            'November': '11',
            'December': '12'
        }

        let splitDate = evt.target.value.split('-');

        let monthNum = splitDate[1]

        let monthText = Object.keys(dateConverter).find(key => dateConverter[key] === monthNum);

        let abrMonthText;

        if (monthText === 'September') {
            abrMonthText = monthText.substring(0, 4)
        } else if (!monthText) {
            abrMonthText = ''
        } else {
            abrMonthText = monthText.substring(0, 3)
        }

        // convert from user input date to day of the week
        let dayConverter = {
            'Sun': '0',
            'Mon': '1',
            'Tue': '2',
            'Wed': '3',
            'Thu': '4',
            'Fri': '5',
            'Sat': '6'
        }

        let defaultTime = "07:00:00";

        let dayOfTheWeekNum = new Date(monthText + " " + splitDate[2] + ", " + splitDate[0] + " " + defaultTime).getDay().toString();

        let dayOfTheWeek = Object.keys(dayConverter).find(key => dayConverter[key] === dayOfTheWeekNum);

        this.setState({
            newEvent: {
                ...this.state.newEvent,
                month: abrMonthText.toUpperCase(),
                date: splitDate[2],
                year: splitDate[0],
                abrMonthText: abrMonthText,
                dayOfTheWeek: dayOfTheWeek
            }
        })
    }

    addEventTime = (evt) => {

        let time = evt.target.value

        let hour = time.split(':')[0];

        let min = time.split(':')[1];

        if (hour < '12') {
            time += 'am'
        } else {
            time = (Number(hour) - 12) + ":" + min + 'pm'
        }

        this.setState({
            newEvent: {
                ...this.state.newEvent,
                time: time
            }
        })
    }

    addEventLink = (evt) => {
        this.setState({
            newEvent: {
                ...this.state.newEvent,
                link: evt.target.value
            }
        })
    }

    addEventImage = (evt) => {
        let reader = new FileReader();
        if (evt.target.files[0]) {
            reader.readAsDataURL(evt.target.files[0]);
        }
        reader.onload = () => {
            this.setState({
                newEvent: {
                    ...this.state.newEvent,
                    img: reader.result
                }
            })
        }
    }

    addNewEvent = () => {
        this.setState({
            newEvent: {
                ...this.state.newEvent,
                location: this.state.newEvent.place + ", " + this.state.newEvent.city + ", " + this.state.newEvent.state,
                dmyTime: this.state.newEvent.dayOfTheWeek + ", " + this.state.newEvent.abrMonthText + " " + this.state.newEvent.date + ", " + this.state.newEvent.year + " " + this.state.newEvent.time,
                organizer: this.props.user.uid
            }
        },

            () => {
                let newEventKey = firebase.database().ref().child('posts').push().key;
                let updates = {};
                // push a newly created event to firebase
                updates['/allData/events/' + newEventKey] = this.state.newEvent;
                firebase.database().ref().update(updates);
                this.setState({ modal: false, newEvent: {} })
            }
        )
    }

    cancelCreateEvent = () => {
        this.setState({ modal: false, newEvent: {} });
    }

    render() {
        return (
            <Col sm="12" md="6" xl="4" className="mb-4">
                <Card className="h-100 justify-content-center bg-color-theme-5" width="100%" inverse onClick={this.toggle}>
                    <CardImg role="button" top width="100%" src="img/add-program-button.png" alt="add new event" />
                </Card>

                <Modal isOpen={this.state.modal} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>Event Details</ModalHeader>
                    <ModalBody>
                        <Form>
                            <FormGroup>
                                <Label>Event Title</Label>
                                <Input type="text" placeholder="Give it a short distinct name" onChange={this.addEventTitle} />
                            </FormGroup>
                            <FormGroup>
                                <Label>Location</Label>
                                <Input type="text" placeholder="Enter a location" onChange={this.addEventPlace} />
                            </FormGroup>
                            <Row form>
                                <Col md={5}>
                                    <FormGroup>
                                        <Label>City</Label>
                                        <Input type="text" onChange={this.addEventCity} />
                                    </FormGroup>
                                </Col>
                                <Col md={5}>
                                    <FormGroup>
                                        <Label>State</Label>
                                        <Input type="text" maxLength="2" onChange={this.addEventState} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <FormGroup>
                                <Label>Date</Label>
                                <Input
                                    type="date"
                                    placeholder="date placeholder"
                                    onChange={this.addEventDate}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Time</Label>
                                <Input
                                    type="time"
                                    placeholder="time placeholder"
                                    onChange={this.addEventTime}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Link</Label>
                                <Input type="text" placeholder="Enter a Facebook link to event description" onChange={this.addEventLink} />
                            </FormGroup>
                            <FormGroup>
                                <Label>File</Label>
                                <Input type="file" onChange={this.addEventImage} />
                                <FormText color="muted">
                                    Upload an image for your event!
                                    <br />
                                    Please be aware that images not in the 16:9 ratio may be distorted.
                                </FormText>
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.addNewEvent} disabled={!this.state.newEvent.eventTitle || !this.state.newEvent.place || !this.state.newEvent.city || !this.state.newEvent.state || !this.state.newEvent.date || !this.state.newEvent.time || !this.state.newEvent.link || !this.state.newEvent.img}>Submit</Button>
                        <Button onClick={this.cancelCreateEvent}>Cancel</Button>{' '}
                    </ModalFooter>
                </Modal>
            </Col>
        );
    }
}

export class RenderEventCard extends Component {
    // remove an event from firebase based on the event id
    removeEvent = () => {
        this.props.removeEvent(this.props.data.id);
    }

    render() {
        let events = this.props.data;
        let button;
        if (this.props.displayMine) {
            button = <Button color="danger" size="sm" onClick={this.removeEvent}>Remove Event</Button>;
        }

        return (
            <Col sm="12" md="6" xl="4" className="mb-4">
                <Card className="h-100">
                    <a role="button" href={events.link}><CardImg top width="100%" className="card-image" src={events.img} alt={events.eventTitle} /></a>
                    <CardBody>
                        <Container>
                            <Row>
                                <Col md="3" className="d-none d-md-block text-center">
                                    <p className="date-month">{events.month}</p>
                                    <p className="date-date">{events.date}</p>
                                </Col>
                                <Col sm="12" md="9">
                                    <CardTitle><h2 className="title-bd font-size-title">{events.eventTitle}</h2></CardTitle>
                                    <CardText className="body-lt font-size-event-details">
                                        {events.dmyTime}
                                    </CardText>
                                    <CardText className="body-lt font-size-event-details">
                                        {events.location}
                                    </CardText>
                                </Col>
                            </Row>
                        </Container>
                    </CardBody>
                    {button}
                </Card>
            </Col>
        );
    }
}
